import React from "react";
import { useForm } from "react-hook-form";

function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);
  console.log(errors);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-11/12 gap-y-5 flex flex-col overflow-hidden">
      <div className="w-full flex justify-between">
        <input
          className="pl-2 pb-1 rounded-lg bg-transparent placeholder-white tracking-wider border-b border-white"
          type="text"
          placeholder="Full name"
          {...register("Full name", { required: true, min: -1 })}
        />
        <input
          className="pl-2 pb-1 rounded-lg bg-transparent placeholder-white tracking-wider border-b border-white"
          type="text"
          placeholder="Company"
          {...register("Company", { max: 100, maxLength: 100 })}
        />
      </div>
      <input
        className="pl-2 pb-1 rounded-lg bg-transparent placeholder-white tracking-wider border-b border-white"
        type="text"
        placeholder="Title"
        {...register("Title", { required: true, max: 30, maxLength: 30 })}
      />
      <div className="w-full flex justify-between">
        <input
          className="pl-2 pb-1 rounded-lg bg-transparent placeholder-white tracking-wider border-b border-white"
          type="text"
          placeholder="Email"
          {...register("Email", { required: true, pattern: /^\S+@\S+$/i })}
        />
        <input
          className="pl-2 pb-1 rounded-lg bg-transparent placeholder-white tracking-wider border-b border-white"
          type="number"
          placeholder="Phone"
          {...register("Phone", { required: true, max: 15, maxLength: 9 })}
        />
      </div>

      <textarea
      rows={4}
        className="pl-2 pb-1 rounded-lg bg-transparent placeholder-white tracking-wider border-b border-white"
        type="text"
        placeholder="Message"
        {...register("Message", { required: true, maxLength: 200 })}
      />

      <input type="submit" className="cursor-pointer py-2 rounded-lg bg-white bg-opacity-20 mx-44 hover:bg-black hover:bg-opacity-20"/>
    </form>
  );
}

export default ContactForm;
